module.exports = __webpack_public_path__ + "static/media/location.2898c4c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/location.svg
// module id = 595
// module chunks = 1